import { produce } from 'immer';

import * as actions from './actions';

export default produce((state, action) => {
  switch (action.type) {

  case actions.SET_SHOW_ARCHIVED_PLANS:
    state.showArchivedPlans = action.showArchivedPlans;
    break;
  }
}, {});
